import { Component, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { NSUnitTrainConstants } from '@ruby/configs/unit-train.constants';
import { IUnitTrainFilters, IUTFiltersConfigurations } from '@ruby/modules/unit-train/models/unit-train.interface';
import * as UTAdvanceSearchActions from '@ruby/modules/unit-train/store/actions/ut-advance-search.actions';
import * as fromUTAdvanceSearch from '@ruby/modules/unit-train/store/reducers/ut-advance-search.reducer';
import * as UTAdvanceSearchSelectors from '@ruby/modules/unit-train/store/selectors/ut-advance-search.selectors';

@Component({
  selector: 'ng-ut-results-vessel-container',
  templateUrl: './ut-results-vessel.container.html',
  styleUrls: ['./ut-results-vessel.container.scss']
})
export class UTResultsVesselContainer implements OnDestroy {
  filtersConfigs: Partial<IUTFiltersConfigurations> = NSUnitTrainConstants.utCalendarFiltersConfigs.vessel;
  store$: Observable<fromUTAdvanceSearch.State>;

  constructor(private store: Store<fromUTAdvanceSearch.State>) {
    this.store$ = this.store.select(UTAdvanceSearchSelectors.selectUTAdvanceSearchState);
  }

  ngOnDestroy(): void {
    this.store.dispatch(UTAdvanceSearchActions.resetAdvanceSearchState());
  }

  /**
   * Make Advance Search
   *
   * @summary emit an event to make a search
   * @param $filters: IUnitTrainFilters
   * @return void
   */
  makeAdvanceSearch($filters: IUnitTrainFilters): void {
    this.store.dispatch(UTAdvanceSearchActions.getVesselEvents({ data: $filters }));
  }
}
